export function n_format(number, fixDecimal = null, separatorThous = null, separatorDeci = null) {
    return parseFloat((isNaN(number ?? 0) || (number ?? 0) == Infinity) ? 0 : number ?? 0).toLocaleString('en', { minimumFractionDigits: fixDecimal ?? 2, maximumFractionDigits: fixDecimal ?? 2 }).replaceAll(",", separatorThous ?? " ").replaceAll(".", separatorDeci ?? ".");
}
